

function ShowCartCount(variant_id){
   var xhttp = new XMLHttpRequest();
   xhttp.onreadystatechange = function() {
     if (this.readyState == 4 && this.status == 200) {
       var cart = JSON.parse(this.responseText);
       var item_id = variant_id

        
        document.querySelector('#myTextcoun').innerText = (cart.item_count);
        $('.sucess-'+item_id).addClass('succ_1')
        $('.maintex-'+item_id).addClass('main_cl')
  
            setTimeout(function () { 
             
               $('.sucess-'+item_id).removeClass('succ_1')
                $('.maintex-'+item_id).removeClass('main_cl')
            }, 4000);
     }
   };
   xhttp.open("GET", "/cart.js", true);
   xhttp.setRequestHeader("Content-Type", "application/json;");
   xhttp.send();
}
function addItemToCart(variant_id, qty) {
  
  var data = {"id": variant_id,"quantity": qty}
  var xhttp = new XMLHttpRequest();
  xhttp.onreadystatechange = function() {
    if (this.readyState == 4 && this.status == 200) {
      ShowCartCount(variant_id);
    }
  };
  xhttp.open("POST", "/cart/add.js", true);
  xhttp.setRequestHeader("Content-Type", "application/json;");
  xhttp.send(JSON.stringify(data));

 
}

 